import classNames from "classnames";
import map from "lodash/map";
import pluralize from "pluralize";
import React from "react";
import {Nav, Tab} from "react-bootstrap";

import {Card} from "@/components/card/Card.tsx";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import ReactUtils from "@/legacy/ReactUtils.jsx";
import TransactionUtils from "@/legacy/transaction/TransactionUtils.jsx";
import Utils from "@/legacy/Utils.js";

const STEP_TYPES = ["command", "variable", "validation"];

export default class StepCommandSelector extends React.Component {
  constructor(props) {
    super(props);
    Utils.autoBindClass(this);

    this.state = {
      filterText: "",
    };

    this.wrapperRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.props.visible && this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      this.setState({filterText: ""});
      this.props.onAddStepComplete(null);
    }
  }

  handleStepTypeSelect(e, step_key) {
    this.setState({filterText: ""});
    this.props.onAddStepComplete(step_key);
  }

  handleFilterTextChange(value) {
    this.setState({filterText: value});
  }

  handleFilterTextEnter(e) {
    if (e.which !== 13) {
      return;
    }

    for (let i = 0; i < STEP_TYPES.length; i++) {
      var entries = this.filterStepDefs(STEP_TYPES[i], this.state.filterText);
      if (entries.length > 0) {
        this.handleStepTypeSelect(entries[0]);
        window.blur();
        return;
      }
    }
  }

  filterStepDefs(stepType, filterText) {
    filterText = filterText.toLowerCase();

    return this.props.transactionStepDefs.filter(
      function (v) {
        const step_key = v[0],
          step_def = v[1];
        return (
          this.props.onCheckStepCanBeAdded(step_key) &&
          step_def.step_type === stepType &&
          (!filterText || step_def.verbose_name.toLowerCase().indexOf(filterText) !== -1)
        );
      }.bind(this)
    );
  }

  render() {
    const tabs = ["pagespeed", "command", "variable", "validation"].map((step) => ({
      name: step,
      title: pluralize(step, 2),
      steps: this.filterStepDefs(step, this.state.filterText),
    }));

    return (
      <Card
        variant="white"
        className={classNames("step-select p-3", {"d-none": !this.props.visible})}
        ref={this.wrapperRef}
        id={this.props.id || "stepSelect"}
      >
        <Tab.Container defaultActiveKey={this.props.defaultActiveKey || "command"}>
          <Nav variant="tabs" defaultActiveKey={this.props.defaultActiveKey || "command"}>
            {tabs
              .filter((item) => item.steps.length > 0)
              .map((item) => (
                <Nav.Item key={item.title} role="presentation">
                  <Nav.Link className="text-capitalize" eventKey={item.name}>
                    {item.title}
                  </Nav.Link>
                </Nav.Item>
              ))}
          </Nav>
          <SearchInput
            className="my-3"
            value={this.state.filterText}
            onChange={this.handleFilterTextChange}
            onKeyDown={this.handleFilterTextEnter}
          />
          <Tab.Content>
            {tabs
              .filter((item) => item.steps.length > 0)
              .map((item) => (
                <Tab.Pane eventKey={item.name} key={item.title}>
                  {this.renderSection(item.name, item.title, item.steps)}
                </Tab.Pane>
              ))}
          </Tab.Content>
        </Tab.Container>
      </Card>
    );
  }

  renderSection(cssClass, name, stepDefs) {
    return (
      <div className={cssClass}>
        <ul className="step-item list-unstyled">{this.renderList(stepDefs)}</ul>
      </div>
    );
  }

  renderList(stepDefs) {
    return map(
      stepDefs,
      function (def_pair) {
        const step_key = def_pair[0],
          step_def = def_pair[1],
          title = TransactionUtils.getFirstSentence(step_def.help_text);
        return (
          <li key={step_key}>
            <a
              onClick={(e) => {
                this.handleStepTypeSelect(e, step_key);
              }}
              title={title}
              dangerouslySetInnerHTML={{__html: this.formatDescription(step_def.verbose_name)}}
            />
          </li>
        );
      }.bind(this)
    );
  }

  formatDescription(name) {
    return ReactUtils.escapeHTML(name).replace(/``(.*?)``/g, '<span class="user-value">$1</span>');
  }
}

StepCommandSelector.defaultProps = {
  transactionStepDefs: [],
};
